
import Vue from 'vue'

export default Vue.extend({
  name: 'R-Layout',
  props: {
    type: {
      type: String,
    },
  },
  computed: {
    layout() {
      return this.type ? () => import(`./${this.type}`) : 'div'
    },
  },
})
